<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- CE in Progress -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">{{title}}</span>
                </div>
              </b-col>
              <b-col v-if="rows !== 0" cols="12">
                  <span class="txt-section-subtitle red">Pending exams: {{totalRows | prettyNumber}}</span>
              </b-col>
            </b-row>
          </div>

          <b-card v-if="rows === 0">
            <p>You currently do not have any classes in progress.</p>
          </b-card>

          <!-- TBD classList component. -->
          <div v-if="rows !== 0" class="div-section-body">
            <b-row v-for="row in classes" v-bind:key="row.classid" class="mt-4" @click.prevent="gotoClass(row.hash)">
              <b-col cols="4" class="text-center">
                <!-- {{row.classid}} -->
                <b-img fluid v-bind:src="row.photo" />
                <div class="mt-2">
                  <!-- <b-button size="sm" :to="{ path: '/classroom/'+row.hash }">Classroom</b-button> -->
                  <b-button size="sm">Classroom</b-button>
                </div>
              </b-col>
              <b-col cols="8" style="margin-left: -20px;">
                <div class="class-title">{{row.className}}</div>
                <div class="class-details">
                  {{row.speakerName}}
                  <br>{{row.sponsorCompanyName}}
                  <br>{{row.releaseDate | prettyDate}}
                  <br>{{row.credits}} CEU ({{row.ceTypeId | prettyCEType}})
                </div>
              </b-col>
            </b-row>

            <b-row v-if="pages > 0" class="mt-4">
              <b-col>
                <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
              </b-col>
            </b-row>

          </div>
        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  loading: true,
  error: false,
  studentHash: '',
  title: "CE in Progress",
  blurb: "",
  classes: [],
  totalRows: 0,
  pageSize: 0,
  pages: 0,
  curPage: 1
}

export default {
  name: "Pending",
  data() {
    return data;
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "0"
    }
  },
  computed: {
    rows () {
      return this.classes.length
    }
  },
  methods: {
    gotoClass(hash) {
      this.$router.push(`/classroom/${hash}`)
    },
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doPending()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '/pending' : `/pending/${pageNum-1}`
    },
    doPending() {
      this.loading = true
      this.classes = []
      service
        .getPending(this.studentHash,this.curPage-1)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Pending exams: ${res.rowCount}`
            this.classes = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
          } else {
            this.blurb = "All exams completed.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.studentHash = this.$root.getToken();
    // console.log(`page: ${this.page}  h: ${this.studentHash}`)
    this.doPending()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pending.vue